import { http } from '@/utils/http';
import qs from 'qs';

const urlPrefix = '/vote/2019poject/2019ljby/controller.php?enews=';
// 获取列表
export const getlist = (
  voteName: string,
  page: number,
  type: string,
  street: string,
  data?: any,
) => {
  const search = data ? `&search=${data.toString()}` : '';
  return http.get(
    `${urlPrefix}vote-list&page=${page}&street=${street}&type=${type}${search}`,
  );
};

// 获取详情
export const getDetail = (id: string | number, type: string | number) => {
  return http.get(`${urlPrefix}detail&id=${id}`);
};
